import { defineGameCard, onResolve, unitTarget } from '../authoring/index.js';
import { plannedUnitId } from './slime-helpers.js';
export const CrushAndStrainCard = defineGameCard({
    id: 'crush_and_strain',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: {
            target: unitTarget({
                side: 'ally',
                cardinality: { min: 1, max: 1 },
                where: ({ unit }) => unit.traits.includes('SLIME'),
            }),
        },
    },
    presentation: {
        name: 'Раздавить и процедить',
        description: 'Выберите своего слизня и уничтожьте его. Если это удалось, возьмите 3 карты.',
        glyph: {
            colors: ['#10213A', '#29292A', '#697D8C', '#569E2E', '#9ECE16'],
            rows: [
                '......11222211......',
                '.......122331.......',
                '.......123331.......',
                '.......133331.......',
                '.......133331.......',
                '...11111333311111...',
                '..1223333333333331..',
                '..1233333333333331..',
                '..1333333333333331..',
                '..1111111111111111..',
                '...1455555555541....',
                '...15522555225441...',
                '...15555525555441...',
                '..1554542554554441..',
                '.14555555555544441..',
                '..1114554444444441..',
                '.....111111111111...',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [onResolve((ctx) => {
            const targetId = plannedUnitId(ctx, 'target');
            const target = targetId === undefined ? null : ctx.q.instance(targetId);
            if (target === null || target.zone !== 'board')
                return;
            ctx.ops.destroy(target.id);
            const after = ctx.q.instance(target.id);
            if (target.isToken || after === null || after?.zone !== 'board') {
                ctx.ops.drawCard(ctx.self.controllerId, 3);
            }
        })],
    ui: {
        mechanics: ['death'],
        planning: { steps: { target: { label: 'Выберите слизня' } } },
    },
});
//# sourceMappingURL=crush_and_strain.js.map